export const transactions = [
  {
    id: 1,
    transactionId: "TXN-HSBC-001",
    type: "Withdrawal",
    label: "Withdrawn to HSBC Bank",
    date: "Mar 12, 2025, 07:20 am",
    amount: 3751,
    balance: 2999,
    color: "#EF4444",
    status: "Completed",
    method: "Bank Transfer",
    category: "Banking",
    note: "Transferred to HSBC savings account.",
  },
  {
    id: 2,
    transactionId: "TXN-CHASE-002",
    type: "Purchased",
    label: "Purchased from Chase Bank",
    date: "Mar 10, 2025, 05:48 pm",
    amount: 3000,
    balance: 6750,
    color: "#22C55E",
    status: "Completed",
    method: "Bank Transfer",
    category: "Banking",
    note: "Received from Chase checking account.",
  },
  {
    id: 3,
    transactionId: "TXN-HEART-003",
    type: "Expense",
    label: "John Doe paid for heart card",
    date: "Mar 08, 2025, 05:48 pm",
    amount: 250,
    balance: 3750,
    color: "#22C55E",
    status: "Completed",
    method: "Card",
    category: "Health",
    note: "Paid for heart card session with John Doe.",
  },
  {
    id: 4,
    transactionId: "TXN-LIVE-004",
    type: "Expense",
    label: "Paid for Live Event by Alex Dumphy",
    date: "Mar 01, 2025, 05:48 pm",
    amount: 500,
    balance: 3500,
    color: "#EF4444",
    status: "Completed",
    method: "Wallet",
    category: "Live Events",
    note: "Fee for attending Alex Dumphy's live event.",
  },
];

export const transactionsHistory = [
  // Earned
  {
    sn: 1,
    date: "27 Jun 2025",
    type: "Earned",
    amount: +100,
    source: "@jane_sings - Card A",
  },
  {
    sn: 2,
    date: "26 Jun 2025",
    type: "Earned",
    amount: +150,
    source: "@john_doe - Card B",
  },
  {
    sn: 3,
    date: "25 Jun 2025",
    type: "Earned",
    amount: +200,
    source: "@music_queen - Card C",
  },
  {
    sn: 4,
    date: "24 Jun 2025",
    type: "Earned",
    amount: +80,
    source: "@vocal_star - Card D",
  },
  {
    sn: 5,
    date: "23 Jun 2025",
    type: "Earned",
    amount: +120,
    source: "@rap_lord - Card E",
  },

  // Expense (Spent)
  {
    sn: 6,
    date: "27 Jun 2025",
    type: "Spent",
    amount: -100,
    source: 'Booked "GTP X"',
  },
  {
    sn: 7,
    date: "26 Jun 2025",
    type: "Spent",
    amount: -50,
    source: 'Booked "GTP Y"',
  },
  {
    sn: 8,
    date: "25 Jun 2025",
    type: "Spent",
    amount: -75,
    source: 'Booked "GTP Z"',
  },
  {
    sn: 9,
    date: "24 Jun 2025",
    type: "Spent",
    amount: -40,
    source: 'Booked "GTP A"',
  },
  {
    sn: 10,
    date: "23 Jun 2025",
    type: "Spent",
    amount: -90,
    source: 'Booked "GTP B"',
  },

  // Purchased
  {
    sn: 11,
    date: "27 Jun 2025",
    type: "Purchased",
    amount: -200,
    source: "Purchase from card",
  },
  {
    sn: 12,
    date: "26 Jun 2025",
    type: "Purchased",
    amount: -180,
    source: "Purchase from card",
  },
  {
    sn: 13,
    date: "25 Jun 2025",
    type: "Purchased",
    amount: -250,
    source: "Purchase from card",
  },
  {
    sn: 14,
    date: "24 Jun 2025",
    type: "Purchased",
    amount: -300,
    source: "Purchase from card",
  },
  {
    sn: 15,
    date: "23 Jun 2025",
    type: "Purchased",
    amount: -220,
    source: "Purchase from card",
  },

  // Withdrawal (Redeemed)
  {
    sn: 16,
    date: "27 Jun 2025",
    type: "Redeemed",
    amount: -150,
    source: "Redemption #3523 - $15.00",
  },
  {
    sn: 17,
    date: "26 Jun 2025",
    type: "Redeemed",
    amount: -170,
    source: "Redemption #3524 - $17.00",
  },
  {
    sn: 18,
    date: "25 Jun 2025",
    type: "Redeemed",
    amount: -130,
    source: "Redemption #3525 - $13.00",
  },
  {
    sn: 19,
    date: "24 Jun 2025",
    type: "Redeemed",
    amount: -190,
    source: "Redemption #3526 - $19.00",
  },
  {
    sn: 20,
    date: "23 Jun 2025",
    type: "Redeemed",
    amount: -160,
    source: "Redemption #3527 - $16.00",
  },
];
